import Heading from "../../components/heading/Heading";
import React, { FC } from "react";
import st from './contacts.module.scss';

interface ContactsProps {
    orderBtn: JSX.Element
}

const Contacts: FC<ContactsProps> = ({orderBtn}) => {
    return (
        <div className={st['contacts']}>
            <Heading.Card>Наши контакты</Heading.Card>
            <div className={st['contacts__text']}>
                <p><b>Агролаборатория расположена по адресу:</b> <br/>г. Кирово-Чепецк, Западный проезд
                    д.1 <br/>Кировская
                    область, 613040</p>
                <p><b>E-mail для заявок на агрохимический анализ:</b> <br/><a className={st['contacts__email']}
                                                                              href={"mailto:agrolaboratory@uralchem.com"}>agrolaboratory@uralchem.com</a>
                </p>
                <p><b>Руководитель лаборатории</b> <br/>Александрова Марина Игоревна <br/>тел.: 8 (912) 370 07
                    74</p>
            </div>
            {orderBtn}
        </div>
    );
};

export default Contacts;